export function validateEventPayload(payload) {
  const errors = [];
  if (!payload) return { valid: false, errors: ["Missing payload"] };
  const { type, title, date, venue, credit_cap, cutoff } = payload;
  if (!type || !["internal", "external"].includes(type)) {
    errors.push("Event type must be internal or external");
  }
  if (!title || title.trim().length < 3) {
    errors.push("Title is required (min 3 characters)");
  }
  if (!date) {
    errors.push("Date is required");
  }
  if (!venue || venue.trim().length < 3) {
    errors.push("Venue is required (min 3 characters)");
  }
  if (type === "internal") {
    const cap = Number(credit_cap || 0);
    if (!Number.isFinite(cap) || cap < 0) {
      errors.push("Credit Cap must be a non-negative number");
    }
  }
  if (type === "external") {
    const cut = Number(cutoff || 0);
    if (!Number.isFinite(cut) || cut < 0 || cut > 100) {
      errors.push("Cutoff must be between 0 and 100");
    }
  }
  return { valid: errors.length === 0, errors };
}

export function validateCreditAssign({ amount, assignByEmail, email }) {
  const errors = [];
  const amt = Number(amount);
  if (!Number.isFinite(amt) || amt === 0) {
    errors.push("Amount must be a non-zero number");
  }
  if (assignByEmail) {
    if (!email) {
      errors.push("Email is required");
    } else {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!re.test(email.toLowerCase())) {
        errors.push("Enter a valid email address");
      }
    }
  }
  return { valid: errors.length === 0, errors };
}
